import { render, staticRenderFns } from "./qianshuIcon.vue?vue&type=template&id=6a718996&scoped=true"
import script from "./qianshuIcon.vue?vue&type=script&lang=js"
export * from "./qianshuIcon.vue?vue&type=script&lang=js"
import style0 from "./qianshuIcon.vue?vue&type=style&index=0&id=6a718996&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a718996",
  null
  
)

export default component.exports